import { Router, ActivatedRoute } from '@angular/router';
import { EventsService } from './../../services/events.service';
import { RestService } from './../../services/rest.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BackButtonService } from 'src/app/services/back-button.service';
import { SnackbarService } from '@bcl/design-system';
import { ViewWillEnter } from '@ionic/angular';

@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss'],
})
export class DetailsComponent implements OnInit, ViewWillEnter {
  questionvalues: any[] = [];
  errorMessage: string;
  answers: any[] = [];
  warehouses: any[] = [];
  stringval: string;
  orderId: number;
  public ss: string;
  public bb: string;
  public orders: any[] = [];
  public categories: any[] = [];
  public questions: any[] = [];
  public photos: any[] = [];
  public questionsWithAnswers: any[] = [];

  public loading = false;
  public selectedOrder = false;

  private storage: any = {};

  constructor(
    private rest: RestService,
    private events: EventsService,
    private router: Router,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private backButtonService: BackButtonService,
    private snackbarService: SnackbarService
  ) {
    this.orderId = +this.route.snapshot.paramMap.get('id');
  }

  ngOnInit() {
    this.getData();

    this.events.itemCreated.subscribe((success) => {
      if (success) {
        this.rest.getPhotos(this.orderId).then((photos: any) => {
          this.photos = photos;
        });
      }
    });

    this.events.itemSaved.subscribe((success) => {
      if (success) {
        this.getData();
      }
    });

    this.rest.getCategories().then((categories: any) => {
      this.categories = categories;
    });
    this.rest.getQuestions().then((questions: any) => {
      this.questions = questions;
    });
    this.rest.getAnswers(this.orderId).then((answers: any) => {
      this.answers = answers;
    });
    this.rest.getPhotos(this.orderId).then((photos: any) => {
      this.photos = photos;
    });
  }

  ionViewWillEnter() {
    this.setupBackButton();
  }

  getData() {
    this.loading = true;
    this.rest.getOrder(this.orderId).then((order: any) => {
      this.orders = order;
      if (order[0].answers) {
        this.questionvalues = JSON.parse(order[0].answers);
      }
      if (order[0].warehouses) {
        this.warehouses = JSON.parse(order[0].warehouses);
      }
      this.selectedOrder = true;
      this.loading = false;
    });
  }

  save() {
    this.questionsWithAnswers = [];
    for (let j = 0; j < this.categories.length; j++) {
      const filteredQuestions = this.questions.filter(
        (question) => question.category === this.categories[j].categorykey
      );

      for (let i = 0; i < filteredQuestions.length; i++) {
        this.questionsWithAnswers.push({
          question: filteredQuestions[i].question,
          answer:
            typeof this.questionvalues[j * 100 + i] === undefined
              ? null
              : this.questionvalues[j * 100 + i],
        });
      }
    }

    this.rest.saveOrderMobile(this.orderId, this.orders[0]);
    this.rest.saveAnswers(
      this.orderId,
      this.questionvalues,
      this.questions,
      this.questionsWithAnswers
    );

    this.snackbarService.open('green', 'DETAILS_PAGE.MESSAGES.DATA_SAVED');
    this.router.navigate(['']);
  }

  newPhoto() {
    this.router.navigate(['newitem', this.orderId]);
  }

  deletePhoto(photoID: number) {
    this.rest
      .deletePhoto(photoID)
      .then(() => {
        this.rest.getPhotos(this.orderId).then((photos: any) => {
          this.photos = photos;
          this.snackbarService.open(
            'green',
            'DETAILS_PAGE.MESSAGES.PHOTO_DELETED'
          );
        });
      })
      .catch((error) => {
        console.error(error);
        this.snackbarService.open(
          'red',
          'DETAILS_PAGE.MESSAGES.PHOTO_DELETE_ERROR'
        );
      });
  }

  gasMeasurements() {
    this.router.navigate(['gas', this.orderId]);
  }

  changed(key, event, item) {
    // console.log('CUR > ' + JSON.stringify(this.questionvalues));

    this.ss = JSON.stringify(this.questionvalues);
    this.bb = JSON.stringify(item);
  }

  answervalues(vals: any) {
    return vals.split(';');
  }

  pushToArray(arr, obj) {
    const index = arr.findIndex((e) => e.key === obj.key);

    if (index === -1) {
      arr.push(obj);
    } else {
      arr[index] = obj;
    }
  }
  public goToHome(): void {
    this.router.navigate(['/']);
  }
  public goBack() {
    this.dialog.closeAll();
    this.router.navigate(['']);
  }

  private setupBackButton() {
    this.backButtonService.showBackButton({
      show: true,
      action: () => {
        this.goBack();
      },
    });
  }
}
